export const ListingActionsEnum = Object.freeze({
    DELETE: "delete",
    TOGGLE: "toggle",
    EDIT: "edit",
    RESEND: "resend",
    SHOW: "show",
});

export default ListingActionsEnum;